<script>
  import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  async fetchFederalUnits() {
    const response = await axios.get('federal_units', AS.getDefaultHeaders())
    return response.data;
  },
  async fetchCities(federalUnitId) {
    const response = await axios.get(`federal_units/${ federalUnitId }/cities`, AS.getDefaultHeaders())
    return response.data;
  },
};
</script>
